var _jsxFileName = "/codebuild/output/src1718503544/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/Footer/index.tsx";
import React, { useEffect, useRef, useState } from 'react';
import { Divider, Text, VStack } from '@adc/parallax-component-library';
import { Button } from 'Components/utility';
import { checkBrowser } from 'Utilities/browser';
const {
  isAndroid
} = checkBrowser();
const Footer = props => {
  const footerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    // This prevents the footer from moving to the top of screen when the keyboard opens on Android
    if (footerRef.current && isAndroid) {
      var _window$visualViewpor;
      const sumedges = window.innerWidth + window.innerHeight;
      const handleResize = () => {
        const keyboardIsOpen = window.innerWidth + window.innerHeight < sumedges;
        setIsVisible(!keyboardIsOpen);
      };
      (_window$visualViewpor = window.visualViewport) === null || _window$visualViewpor === void 0 || _window$visualViewpor.addEventListener('resize', handleResize);
      return () => {
        var _window$visualViewpor2;
        (_window$visualViewpor2 = window.visualViewport) === null || _window$visualViewpor2 === void 0 || _window$visualViewpor2.removeEventListener('resize', handleResize);
      };
    }
  }, []);
  if (!isVisible) {
    return null;
  }
  if (props.children) {
    const {
      children,
      padding
    } = props;
    return /*#__PURE__*/React.createElement(VStack, {
      padding: padding,
      width: "100%",
      ref: footerRef,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 78,
        columnNumber: 7
      }
    }, children);
  }
  const {
    padding,
    buttonLabel,
    buttonTestID,
    onButtonPress,
    disabled,
    onSecondaryButtonPress,
    secondarySectionLabel,
    secondaryButtonTestID,
    secondaryButtonLabel
  } = props;
  const hasSecondarySetup = onSecondaryButtonPress && secondaryButtonLabel && secondarySectionLabel && secondaryButtonTestID;
  return /*#__PURE__*/React.createElement(VStack, {
    padding: padding,
    width: "100%",
    ref: footerRef,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onPress: () => onButtonPress === null || onButtonPress === void 0 ? void 0 : onButtonPress(),
    testID: buttonTestID,
    disabled: disabled,
    "aria-label": buttonLabel,
    label: buttonLabel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 7
    }
  }), hasSecondarySetup && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    marginTop: "$6",
    marginBottom: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    type: "$bodySmall.default",
    testID: `${secondaryButtonTestID}-title`,
    nativeID: `${secondaryButtonTestID}-title`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 13
    }
  }, secondarySectionLabel), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    label: secondaryButtonLabel,
    onPress: onSecondaryButtonPress,
    testID: secondaryButtonTestID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 13
    }
  }))));
};
export { Footer };